// 공통 변수 별 색상 정리
export const COLORS = {
    '홀더': '#5E45F4',
    '비홀더': '#CDCDD1',
    'FREE': '#AFBFD2',
    'NORMAL': '#8B9BA7',
    'RARE': '#069B99',
    'ELITE': '#0A8AC0',
    'EPIC': '#DF5510',
    'ULTIMATE': '#B40E22',
    'Speed': '#ED5564',
    'Luck': '#15BEA0',
    'Energy': '#FFCE55',
    'Durability': '#4B97C7',
    'Speed (+)': '#ED5564',
    'Speed (%)': '#B30012',
    'Luck (+)': '#15BEA0',
    'Luck (+) (%)': '#00856D',
    'Energy (+)': '#FFCE55',
    'Energy (%)': '#CA9000',
    'Durability (+)': '#4B97C7',
    'Durability (%)': '#00619F',
    'HVH 소비': '#787878',
    'PER 소비': '#F2DF31',
    'XPER 소비': '#E1183D',
    'USDT 소비': '#0A7A7B',
    'HVH 생성': '#19AF00',
    'PER 생성': '#265BE4',
    'XPER 생성': '#FF8515',
    'USDT 생성': '#0BC1BB',
    'XPER 가격': '#FF8515',
    'PER 가격': '#E1183D',
    'HVH 가격': '#265BE4',
    '거래 수수료': '#265BE4',
    'LP 수수료': '#FF8515',
    '생성': '#265BE4',
    '거래 수량': '#19AF00',
    '총 거래 금액': '#474747',
    '평균 거래 금액': '#DE4DC7',
    '총 거래 수수료': '#8B4EEE',
    '등록 수량': '#265BE4',
    '최저 등록 금액': '#FF8515',
    '최고 등록 금액': '#E1183D',
    '평균 등록 금액': '#E2B000',
    '인원수': '#7B66FF',
    '1~10 레벨': '#265BE4',
    '11~20 레벨': '#FF8515',
    '21~30 레벨': '#F2DF31',
    '31~40 레벨': '#19AF00',
    '41 레벨 이상': '#E1183D',
    '총 스펜딩 수': '#E1183D',
    '아이템 생성': '#265BE4',
    '아이템 소각': '#E1183D',
    '보석 생성': '#265BE4',
    '보석 소각': '#E1183D',
    '총 회원 수': '#265BE4',
    '신규 회원 수': '#265BE4',
    '총 홀더 수': '#E1183D',
    '신규 홀더 수': '#E1183D',
    '비홀더 전환 수': '#FF8515',
}